import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-center py-6 mt-10">
      <p className="text-gray-600">
        © 2026 STMZ Group. All rights reserved.
      </p>
    </footer>
  );
}